import * as React from 'react';
import { useParams } from 'react-router-dom';
import * as _ from 'lodash';
import {
  ContentLoading,
  Logging,
  Notification,
} from '@vcd-ecm-ui/Common';
import { VtxTabPane, VtxTabs } from '@vertexinc/vtx-ui-react-component-library';
import useCustomerSettings from './useCustomerSettings';
import CustomerCustomFields from '../CustomerCustomFields/CustomerCustomFields';
import ApprovalSettings from '../ApprovalSettings/ApprovalSettings';
import CustomerSettingsProps from './CustomerSettingsProps.interface';
import '../../Common/common-settings.scss';
import '../customer-settings.scss';

interface ParamTypes {
  tab: string,
}

const CustomerSettings = ({
  gatewayEndPoint,
}: CustomerSettingsProps): JSX.Element => {
  const [notification, setNotification] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const { tab } = useParams<ParamTypes>();

  // Load the Customer Settings
  const [customerSettings, customerSettingsObject, customerSettingsNotification] = useCustomerSettings(gatewayEndPoint);

  // Selected Tab Change
  const onTabChange = (selectedTab: string): void => {
    Logging.Info('Select Tab', selectedTab);
  };

  Logging.Debug('Customer Settings');

  // Loading is Done - Successfull
  React.useEffect(() => {
    setIsLoading(false);
  }, [customerSettings]);

  // Loading is Done - Error
  React.useEffect(() => {
    setIsLoading(false);
    setNotification(customerSettingsNotification);
  }, [customerSettingsNotification]);

  // Notification Error was Closed
  const onCloseNotification = (): void => {
    setNotification(null);
  };

  React.useEffect(() => {
    // This Code will run once after the initial Render
    Logging.Debug('Customer Settings - Initial Render');

    return (): void => {
      // This Code will run once the component unmounts.
      setIsLoading(false);
      setNotification(null);
    };
  }, []);

  const approvalSettingsTab = false;

  return (
    <>
      <div className="customerSettingsContainer">
        <div className="customerSettingsHeader">
          <h2>
            <span>Customer Settings</span>
          </h2>
        </div>
        {
          isLoading
          && (
            <ContentLoading loadingMessage="Loading Customer Settings ..." />
          )
        }
        {
          customerSettings
          && (
            <div className="customerSettingsContent">
              <div className="customerSettingsTabsContainer">
                <VtxTabs defaultActiveKey={tab} onChange={onTabChange}>
                  <VtxTabPane tab="Customer Custom Fields" key="1">
                    <CustomerCustomFields
                      gatewayEndPoint={gatewayEndPoint}
                      settings={customerSettings}
                    />
                  </VtxTabPane>
                  {
                    approvalSettingsTab
                    && (
                      <VtxTabPane tab="Approval Settings" key="2">
                        <ApprovalSettings
                          gatewayEndPoint={gatewayEndPoint}
                          settings={customerSettings}
                        />
                      </VtxTabPane>
                    )
                  }
                </VtxTabs>
              </div>
            </div>
          )
        }
        <Notification
          data={notification}
          onNotificationClose={onCloseNotification}
          autoClose
        />
      </div>
    </>
  );
};

export default CustomerSettings;
